"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicationStats = void 0;
class ApplicationStats {
    constructor() {
    }
    static getAttributeTypeMap() {
        return ApplicationStats.attributeTypeMap;
    }
}
exports.ApplicationStats = ApplicationStats;
ApplicationStats.discriminator = undefined;
ApplicationStats.attributeTypeMap = [
    {
        "name": "appId",
        "baseName": "appId",
        "type": "string",
        "format": ""
    },
    {
        "name": "appUid",
        "baseName": "appUid",
        "type": "string",
        "format": ""
    },
    {
        "name": "messageDestinations",
        "baseName": "messageDestinations",
        "type": "number",
        "format": "int"
    }
];
//# sourceMappingURL=ApplicationStats.js.map